import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head, Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  components: {
    Head: Head,
    Link: Link
  },
  layout: Layout,
  props: {
    tenantList: {
      type: Array,
      "default": []
    }
  },
  data: function data() {
    return {
      tenant: '',
      campaign: '',
      campaignList: [],
      isLoadingSmtpSettings: false,
      smtpSettings: []
    };
  },
  methods: {
    getCampaignList: function getCampaignList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.campaignList = [];
                _this.smtpSettings = [];
                if (!(_this.tenant.length == 0)) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return");
              case 4:
                _this.$store.loading = true;
                _context.next = 7;
                return axios.post('/smtp/list', {
                  tenantId: _this.tenant
                });
              case 7:
                res = _context.sent;
                if (res.data.status == 'success') {
                  _this.campaignList = res.data.campaignList;
                }
                _this.$store.loading = false;
              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSmtpSettings: function getSmtpSettings() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.smtpSettings = [];
                if (_this2.tenant) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return");
              case 3:
                if (_this2.campaign) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return");
              case 5:
                _this2.isLoadingSmtpSettings = true;
                _context2.next = 8;
                return axios.post('/smtp/settings', {
                  tenantId: _this2.tenant,
                  campaignId: _this2.campaign
                });
              case 8:
                res = _context2.sent;
                if (res.data.status == 'success') {
                  _this2.smtpSettings = res.data.smtpSettings;
                }
                _this2.isLoadingSmtpSettings = false;
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    saveSettings: function saveSettings(settings) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.$store.loading = true;
                _context3.next = 3;
                return axios.post('/smtp/store', settings);
              case 3:
                res = _context3.sent;
                _this3.$store.loading = false;
                ElMessage({
                  showClose: true,
                  message: res.data.message,
                  type: res.data.status
                });
                _this3.getSmtpSettings();
              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getRowStyle: function getRowStyle(row, rowIndex) {
      return 'background-color: rgb(226 232 240);';
    }
  }
};